module.exports = __webpack_public_path__ + "img/D201501_2.b37857f3.jpg";